<template>
  <main class="sa-content">
      <div class=" sa-card-large">
        <div class="sa-mob-cont sa-h100">
         <div class="sa-mob-header sa-h-sm-up">
      <h5 class="sa-card-tit">Contact Us</h5>
      <button class="sa-btn-back  sa-h-sm-up" @click="$router.go(-1)">
        <i class="icon-left-arrow "></i>
      </button>
    </div>
        <div class=" sa-contact-box ">
          <div class="sa-row sa-d-f-a-center sa-h100">
            <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
              <h1>Having trouble to use Sanar? We are here to help.</h1>
              <span class="sa-cont-tag email sa-sprite"><span class="sa-gray-text">Email:</span> <a href="mailto:support@sanar.sa" class="sa-text-underline">support@sanar.sa</a></span>
              <!-- <span class="sa-cont-tag chat sa-sprite" @click="chatWithUs">Chat with Us</span> -->
            </div>
            <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
              <img src="../../assets/img/contact-img.svg" alt="Contact us" class="sa-img-res" />
            </div>
          </div>
        </div>
        </div>
      </div>
  </main>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
    chatWithUs() {
      // this.$router.push({path: '/chat-with-a-doctor'})
    }
  }
};
</script>
